<template>
  <ToggleCard
    v-model="model"
    container-id="lottery_ticket_type_form"
    :info-button-aria-label="$t('infobutton.conveniencefee.label')"
    :info-headline="$t('lottery.tickettypetoggle.infobutton.headline')"
    :info-text="$t('lottery.tickettypetoggle.infobutton.text')"
    name="subscription"
    :switch-aria-label-text="$t('lottery.tickettypetoggle.switch.label')"
    :variant="EDITOR_SUBSCRIPTION_VARIANT"
  >
    <template #headline>
      {{ $t('lottery.tickettypetoggle.headline') }}
    </template>

    {{ $t('lottery.tickettypetoggle.text') }}
  </ToggleCard>
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import { EDITOR_SUBSCRIPTION_VARIANT } from '../constants/optionCards'
import { EDITOR_TICKET_TYPE } from '../constants/options'

type Props = {
  lotteryId: LotteryId
}

const { lotteryId } = defineProps<Props>()

const { store } = useEditorOptions(lotteryId)

const model = computed({
  get: () => store.ticketType === EDITOR_TICKET_TYPE.Subscription,
  set: (isActive) =>
    store.setTicketType(isActive ? EDITOR_TICKET_TYPE.Subscription : EDITOR_TICKET_TYPE.Single),
})
</script>
